/**
 * <ai-product-card> — 产品卡片数据容器（Collection 列表场景）
 *
 * 职责：
 * - 为子组件（ai-variant-selector、ai-quick-add-cart）提供产品数据
 * - 通过 <script type="application/json"> 存储 variants 和 options 数据
 * - 不负责任何样式和联动，纯数据容器
 *
 * 用法：
 * <ai-product-card>
 *   <script type="application/json" data-product-variants>{{ product.variants | json }}</script>
 *   <script type="application/json" data-product-options>{{ product.options_with_values | json }}</script>
 *   <article class="your-card">
 *     ...
 *     <ai-quick-add-cart product-id="..." variant-id="..." variant-mode="modal">
 *       <button slot="add-btn">Add to Cart</button>
 *     </ai-quick-add-cart>
 *   </article>
 * </ai-product-card>
 *
 * 子组件通过 this.closest("ai-product-card, ai-product-detail") 查找最近的数据容器，
 * 然后从 <script data-product-variants> 和 <script data-product-options> 读取数据。
 *
 * 组件透明：不创建额外 DOM，不使用 Shadow DOM，AI 可以自由设计内部 HTML 和样式。
 */

if (!customElements.get("ai-product-card")) {
    customElements.define(
        "ai-product-card",
        class AiProductCard extends HTMLElement {
            constructor() {
                super();
            }
            connectedCallback() {
            }
        },
    );
}
